import { PnlGridRow } from 'src/components/star-grid/starGridTypes';
import { PNL_STATEMENT_LINE_DIMENSION } from 'src/components/star-grid/starGridConstants';

/**
 * Temporary WW presentation fallback, approved until the API exposes row styles.
 * Matched against Prophecy on 2026-09-15. Keys are statement elements, not aliases:
 * several sections reuse labels such as "Total Devices". No financial data lives here.
 */
const WW_BOLD_TOTALS: ReadonlySet<string> = new Set([
  'Units - Total Devices',
  'Units - Total Accessories',
  'Units - Total Devices (D&A)',
  'Revenue - Total Devices',
  'Revenue - Total Accessories',
  'Revenue - Subscriptions',
  'Total Revenue',
  'GP - Total Devices',
  'GP - Total Accessories',
  'GP - Subscriptions',
  'Total Gross Profit',
  'Variable - AWS Infra Variable',
  'Variable - Other Corp Alloc - Var',
  'Total Variable Costs',
  'Fixed - Employee Expenses',
  'Fixed - Non-Headcount OPEX',
  'Fixed - Total Device Direct OpEx',
  'Fixed - Other Corp Alloc - Fixed',
  'Fixed - FC/CS Fixed',
  'Fixed - Total Allocated Fixed Costs',
  'Total Fixed Costs',
  'Total Operating Expense',
  'Operating Income'
]);

export const wwStatementRowClass = (row: PnlGridRow | undefined, reportFamily?: string): string | undefined => {
  const element = row?.[PNL_STATEMENT_LINE_DIMENSION];
  if (reportFamily !== 'WW Report' || typeof element !== 'string') return undefined;
  if (WW_BOLD_TOTALS.has(element)) return 'sg-pnl-statement-total';
  return element === 'Contribution Profit' ? 'sg-pnl-statement-label-total' : undefined;
};

const WW_SECTION_ENDS: ReadonlySet<string> = new Set([
  'Units - Total Devices (D&A)',
  'Total Revenue',
  'Total Gross Profit',
  'Total Variable Costs',
  'Contribution Profit',
  'Total Fixed Costs',
  'Total Operating Expense'
]);
const TOTAL_ROW_PADDING = 10;
const SECTION_ROW_GAP = 20;

export const wwStatementSpacingClass = (row: PnlGridRow | undefined, reportFamily?: string): string | undefined => {
  if (!wwStatementRowClass(row, reportFamily)) return undefined;
  return WW_SECTION_ENDS.has(String(row?.[PNL_STATEMENT_LINE_DIMENSION])) ? 'sg-pnl-section-end' : 'sg-pnl-total-spacing';
};

export const wwStatementRowHeight = (row: PnlGridRow | undefined, reportFamily: string | undefined, height: number): number => {
  const spacing = wwStatementSpacingClass(row, reportFamily);
  if (!spacing) return height;
  return height + TOTAL_ROW_PADDING + (spacing === 'sg-pnl-section-end' ? SECTION_ROW_GAP : 0);
};
